var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAngleDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.83301 7.83329C1.83301 7.40686 1.99576 6.98022 2.32126 6.65524C2.97226 6.00424 4.02688 6.00424 4.67788 6.65524L11.8324 13.8121L18.9881 6.65524C19.6391 6.00424 20.6938 6.00424 21.3448 6.65524C21.9958 7.30624 21.9958 8.36086 21.3448 9.01186L13.012 17.3446C12.361 17.9956 11.3063 17.9956 10.6554 17.3446L2.32256 9.01186C1.99446 8.68636 1.83301 8.25982 1.83301 7.83329Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngleDown);
export default __webpack_public_path__ + "static/media/angle-down.de95874b5ce112cefad9809ab355a962.svg";
export { ForwardRef as ReactComponent };